module.exports = __webpack_public_path__ + "static/media/location.a028bef1.svg";